import React, { Component, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import { IconButton, Card } from "@mui/material";
import PropTypes from "prop-types";
import clsx from "clsx";
import { compose } from "redux";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  updateWidgetHeight,
  deleteWidget
} from "../../redux/actions/widgetsActions";
import CloseIcon from "@mui/icons-material/Close";
import DashboardWidgetContent from "./DashboardWidgetContent";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    margin: "auto",
    position: "absolute",
    height: "100%",
    bottom: 0,
    left: 0,
    right: 0,
    overflowY: "hidden"
  },
  bgColor: {
    backgroundColor: theme.palette.primary.light
  },
  deleteIcon: {
    position: "absolute",
    left: -21,
    top: -21,
    backgroundColor: theme.palette.primary.light,
    zIndex: 20,
    "&:hover": {
      backgroundColor: theme.palette.primary.light
    }
  }
}));

const DeleteWidgetIcon = ({ onClick }) => {
  const classes = useStyles();
  return (
    <IconButton
      className={classes.deleteIcon}
      color="primary"
      onClick={() => onClick()}
      size="large"
    >
      <CloseIcon />
    </IconButton>
  );
};

const DashboardWidget = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [collapsed, setCollapsed] = useState(false);
  const {
    children,
    title,
    headerAction,
    dropdownProps,
    menuProps,
    widgetKey,
    footer,
    subheader,
    editWidgetMode,
    deleteWidget,
    fadeEffect,
    dashboard
  } = props;

  const handleDeleteWidget = () => {
    deleteWidget(widgetKey, dashboard);
  };

  const handleWidgetSizeChange = height => {
    if (!editWidgetMode) {
      props.updateWidgetHeight(height, widgetKey);
    }
  };

  const defaultMenuOptions = [
    {
      value: "collapse",
      label: t("dashboardWidget.options.collapse")
    }
  ];

  const defaultMenuItemClick = item => {
    if (item.value === "collapse") {
      setCollapsed(!collapsed);
    }
  };

  return (
    <>
      {editWidgetMode && <DeleteWidgetIcon onClick={handleDeleteWidget} />}
      <Card
        data-qa="dashboard-widget-card"
        className={clsx(classes.root, {
          filled: props.filled,
          [classes.bgColor]: props.bgColor
        })}
      >
        <DashboardWidgetContent
          title={title}
          headerAction={headerAction}
          dropdownProps={dropdownProps}
          footer={footer}
          subheader={subheader}
          onSize={handleWidgetSizeChange}
          menuProps={menuProps}
          defaultMenuOptions={defaultMenuOptions}
          defaultMenuItemClick={defaultMenuItemClick}
          collapsed={collapsed}
          fadeEffect={fadeEffect}
        >
          {children}
        </DashboardWidgetContent>
      </Card>
    </>
  );
};

class DashboardWidgetContainer extends Component {
  render() {
    return <DashboardWidget {...this.props} />;
  }
}

const mapStateToProps = state => ({
  editWidgetMode: state.widgetsState.editWidgetMode
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateWidgetHeight,
      deleteWidget
    },
    dispatch
  );
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  DashboardWidgetContainer
);

DashboardWidgetContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  headerAction: PropTypes.any,
  dropdownProps: PropTypes.object,
  menuProps: PropTypes.object,
  footer: PropTypes.node,
  /**
   * Fixed section below widget header and above scrollable widget content
   **/
  subheader: PropTypes.node,
  editWidgetMode: PropTypes.bool,
  widgetKey: PropTypes.string,
  deleteWidget: PropTypes.func,
  fadeEffect: PropTypes.bool,
  dashboard: PropTypes.string
};
